<ng-container #dynamicNotificationContainer></ng-container>

<div *ngIf="loadingLib"
     class="aztec-scanner__loading">
    <app-container-spinner></app-container-spinner>
</div>

<ng-template #mainView>
    <div class="aztec-scanner__main-view">
        <div class="aztec-scanner__main-view--header">
            <img class="aztec-scanner__main-view--header__image" [src]="logoUrl">
        </div>

        <div class="aztec-scanner__main-view--information-text">
            <div [innerHTML]="mainViewHeaderInformationText | safeHtml"></div>
        </div>

        <div class="aztec-scanner__main-view--content text-center">
            <div>
                <ng-container *ngIf="cameraErrorMode && !waitingForDataMode">
                    <img class="aztec-scanner__main-view--content__image"
                         [src]="assetsService.informationDialogImageSrc">
                    <div>
                        <span class="text-grey"> {{ (TRANSLATION_KEY + ".cameraDeviceError") | translate }} </span>
                    </div>
                </ng-container>

                <ng-container *ngIf="!cameraErrorMode && !waitingForDataMode">
                    <img class="aztec-scanner__main-view--content__image" [src]="assetsService.informationDialogImageSrc">
                </ng-container>

                <ng-container *ngIf="waitingForDataMode">
                    <div id="spinner" class="spinner-wrapper">
                        <div class="lds-spinner">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="!waitingForDataMode" class="aztec-scanner__main-view--button__container">
                <div>
                    <button *ngIf="!cameraErrorMode"
                            class="aztec-scanner__main-view--button__container--btn btn btn--secondary"
                            (click)="startScanning()">
                        {{ (TRANSLATION_KEY + ".startScanningButton") | translate }}
                    </button>
                    <br><br>
                    <div class="aztec-scanner__main-view--button__container--text">
                        <span *ngIf="!cameraErrorMode"> {{ (TRANSLATION_KEY + ".mainViewBtnContainerFirstTxt") | translate }} </span>
                        <span> {{ (TRANSLATION_KEY + ".mainViewBtnContainerSecondTxt") | translate }} </span>
                    </div>
                </div>

                <br>
                <button class="aztec-scanner__main-view--button__container--btn aztec-scanner__main-view--button__container--btn__insert-data btn btn--outline"
                        (click)="closeDialog()">
                    {{ (TRANSLATION_KEY + ".writeDataButton") | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cameraContent>
    <div class="aztec-scanner__main-view">
        <div class="aztec-scanner__main-view--header">
            <img class="aztec-scanner__main-view--header__image" [src]="logoUrl">
        </div>

        <div class="aztec-scanner__main-view--information-text"
             [innerHTML]="(TRANSLATION_KEY + '.scanViewInformationText') | translate | safeHtml">
        </div>

        <div class="aztec-scanner__main-view--content">
            <div id="cameraContainer" class="aztec-scanner__camera-container">
            </div>
        </div>

        <button class="btn btn--secondary aztec-scanner__main-view--button__container--btn" (click)="stopScanning()">
            {{ (TRANSLATION_KEY + ".stopScanningButton") | translate }}
        </button>
    </div>
</ng-template>


